/**
 * 用户协议服务
 * 从 AZ_AI_MVR_H5/src/services/Admin/account.ts 迁移
 */
import request from "../../utils/request";

/** 获取用户协议状态 */
export function getUserAgreementUserid(userId: string) {
  return request
    .post("/project/useragreement/getuseragreementuserid", null, {
      params: { userId },
    })
    .then((r) => r.data);
}

/** 提交用户同意协议 */
export function postCreateUserAgreement(data: { UserId: string; IsAgreement: boolean }) {
  return request
    .post("/project/useragreement/create", {
      Entity: data,
    })
    .then((r) => r.data);
}
